<template>
  <div v-if="loading" class="page-center">
    <div class="page-center-box text-center">
      <ui-loading-page />
    </div>
  </div>
  <div v-else>
    <div class="page-title">Заявки на лизинг</div>
    <div class="hr mb-4"></div>

    <div v-if="leasings.length === 0" class="position-relative no-list-data">
      <ui-no-data-page text="Список заявок пуст" />
    </div>

    <div v-else>
      <ui-table>
            <table class="table">
              <thead>
                <tr class="text-nowrap">
                  <th>№</th>
                  <th>Дата расчета</th>
                  <th>Предмет лизинга</th>
                  <th>Поставщик</th>
                  <th class="text-end">Сумма расчета</th>
                  <th class="text-end">Аванс</th>
                  <th>Срок лизинга</th>
                  <th>Статус</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in leasings" :key="index">
                  <td>
                    <RouterLink :to="`/leasings/${item.Id}`">{{
                      item.Id
                    }}</RouterLink>
                  </td>
                  <td>
                    {{ item.Created ? dateMask(item.Created) : "&#8212;" }}
                  </td>
                  <td
                    class="text-truncate"
                    style="max-width: 320px"
                    :title="item.Name ? item.Name : ''"
                  >
                    {{ item.Name ? item.Name : "&#8212;" }}
                  </td>
                  <td
                    class="text-truncate"
                    style="max-width: 320px"
                    :title="item.SupplierName ? item.SupplierName : ''"
                  >
                    {{ item.SupplierName ? item.SupplierName : "&#8212;" }}
                  </td>
                  <td class="text-end text-nowrap">
                    {{ item.Amount ? moneyMask(item.Amount) : "&#8212;" }}
                  </td>
                  <td class="text-end text-nowrap">
                    {{
                      item.Amount && item.Adv
                        ? moneyMask((item.Price * item.Adv) / 100)
                        : "&#8212;"
                    }}
                  </td>
                  <td class="text-nowrap">
                    {{ item.SL ? item.SL + " мес." : "&#8212;" }}
                  </td>
                  <td class="text-nowrap">{{ item.Status == 2 ? item.StatusTextKP : item.StatusText }}</td>
                  <td class="text-end text-nowrap">
                    <RouterLink
                      class="btn btn-base btn-small"
                      :to="`/leasings/${item.Id}`"
                      >Подробнее
                    </RouterLink>
                  </td>
                </tr>
              </tbody>
            </table>
      </ui-table>
    </div>

    <!-- <div class="grid-table grid-table_col-2 mb-3">
      <div class="grid-table__item mb-2">Новых расчетов (КП):</div>
      <div class="grid-table__item mb-2">
        <RouterLink to="/leasing/new">2</RouterLink>
      </div>
      <div class="grid-table__item mb-2">Активная заявка на лизинг:</div>
      <div class="grid-table__item mb-2">
        <RouterLink class="text-decoration" to="/leasing/new"
          >Сбор документов</RouterLink
        >
      </div>
      <div class="grid-table__item mb-2">Сумма активной заявки:</div>
      <div class="grid-table__item mb-2">2 567 000</div>
      <div class="grid-table__item mb-2">Всего расчетов (КП):</div>
      <div class="grid-table__item mb-2">
        <RouterLink to="/leasing/new">3</RouterLink>
      </div>
    </div> -->
    <!-- <RouterLink class="btn btn-ghost" to="/leasing/new"
      >Новый расчет</RouterLink
    > -->
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

import { getApi, dateMask, moneyMask } from "@/run";

const loading = ref(false);
const leasings = ref([]);

const start = () => {
  loading.value = true;

  getApi("/leasings", {}).then((response) => {
    response.leasings && (leasings.value = response.leasings);
    loading.value = false;
  });
};

onMounted(() => {
  document.title = "Заявки на лизинг - STONE-XXI";

  start();
});
</script>

